import Router from "next/router";
import config from "@/libs/config";

export const BizsolRedirectTopPage = () => {
  const fqdn = config.BIZSOL_ANSER_FQDN;
  const env = config.STAGE == "prod" ? "c" : "d";

  const url = `https://${fqdn}/${config.BANK_CODE}${env}/oauth/idconnect_service/return`;
  Router.push(url);

  return <></>;
};
